// Resolve API origin: if running on api subdomain, use relative paths,
// otherwise call the api subdomain on the same domain (https://api.<host>)
const API_ORIGIN = (() => {
  const host = window.location.hostname || '';
  if (!host) return '';
  if (host.startsWith('api.')) return '';
  return `https://api.${host}`;
})();

async function withInitDataFetch(path, options = {}) {
  const initData = window.Telegram?.WebApp?.initData || '';
  const headers = Object.assign({}, options.headers, { 'X-Telegram-Init-Data': initData });
  const url = path.startsWith('/api') ? (API_ORIGIN ? `${API_ORIGIN}${path}` : path) : path;
  const res = await fetch(url, { ...options, headers });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}

export const api = {
  setTimezone: (timezone) =>
    withInitDataFetch('/api/user/timezone', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ timezone })
    }),
  getTasks: () => withInitDataFetch('/api/tasks'),
  createTask: (title, dueTime) =>
    withInitDataFetch('/api/tasks', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ title, dueTime })
    }),
  completeTask: (id) =>
    withInitDataFetch(`/api/tasks/${id}/complete`, { method: 'PATCH' }),
  deleteTask: (id) =>
    withInitDataFetch(`/api/tasks/${id}`, { method: 'DELETE' }),
};
